import { useState, createContext } from 'react';

export const CellDragEnteredContext = createContext({});

export default function CellDragEnteredProvider({children}){

  const [ cellDragEntered, setCellDragEntered ] = useState([-10,-10]);

  const value = { cellDragEntered, setCellDragEntered };
  return (
    <CellDragEnteredContext.Provider value={value}>
      {children}
    </CellDragEnteredContext.Provider>
  )




}
